import { networkNotification } from '@laigu/utils';
import { PRIVATIZATION } from '@laigu/constants';
import SocketWorker from './worker.js?worker&inline';
/**
 * webworker 行内引用 传参需要如上所示，不会走webpack中配置的worker-loader
 * 解决问题关键-》源码断点调试 发现options为空 源码调试也是一种解决思路 可能比网上搜会更加直观
 */
const noop = () => {};
const basename = PRIVATIZATION.CUSTOMIZED_PATH;
class SocketConnect {
  constructor(props) {
    const { socketConfig, openCallback, closeCallback, errorCallback, reconnectCallback, messageCallback } = props;
    this.openCallback = typeof openCallback === 'function' ? openCallback : noop;
    this.closeCallback = typeof closeCallback === 'function' ? closeCallback : noop;
    this.messageCallback = typeof messageCallback === 'function' ? messageCallback : noop;
    this.errorCallback = typeof errorCallback === 'function' ? errorCallback : noop;
    this.reconnectCallback = typeof reconnectCallback === 'function' ? reconnectCallback : noop;

    this.worker = new SocketWorker();

    this.worker.postMessage({ type: 'init', data: { socketConfig } });
    this.worker.onmessage = e => {
      const { type, data } = e.data;
      switch (type) {
        case 'openCallback':
          this.openCallback(data);
          break;
        case 'closeCallback':
          this.closeCallback(data);
          if (data && data.code === 1) {
            window.location.href = `${basename}/auth`;
            return;
          } else if (data && data.code === 2) {
            window.location.href = `${basename}/auth/reached-limit?type=1`;
            return;
          }
          break;
        case 'errorCallback':
          this.errorCallback(data);
          break;
        case 'reconnectCallback':
          this.reconnectCallback(data);
          break;
        case 'messageCallback':
          this.messageCallback(data);
          break;

        case 'networkNotification':
          if (localStorage.getItem('network_prompt_switch') === 'true') {
            networkNotification();
          }
          break;
        case 'socketReconnectMaxCount':
          this.handleSocketReconnectMaxCount();
          break;
        default:
          break;
      }
    };
  }

  showAlert = (message, onRetry) => {
    try {
      const modal = document.createElement('div');
      modal.style.cssText = `
        position: fixed;
        top: 70px;
        left: 50%;
        transform: translateX(-50%);
        background: #f8ecad;
        max-width: 650px;
        width: 100%;
        border-radius: 4px;
        z-index: 9000;
        color: #7c6d1f;
    `;

      const modalContent = document.createElement('div');
      modalContent.style.cssText = `
        display: flex;
        align-items: stretch;
        width: 100%;
        justify-content: space-between;
        min-height:50px;
    `;

      const closeSpan = document.createElement('div');
      closeSpan.style.cssText = `
        cursor: pointer;
        background: rgba(0,0,0,0.1);
        display:flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
    `;
      closeSpan.innerHTML = '重连';
      closeSpan.onclick = () => {
        onRetry();
        document.body.removeChild(modal);
      };

      const messageElement = document.createElement('div');

      messageElement.style.cssText = `
    padding:6px 0 6px 14px;
    display: flex;
    align-items: center;`;
      messageElement.innerText = message;

      modalContent.appendChild(messageElement);
      modalContent.appendChild(closeSpan);
      modal.appendChild(modalContent);
      document.body.appendChild(modal);
    } catch {
      // 忽略重连提示渲染失败
    }
  };
  handleSocketReconnectMaxCount = () => {
    this.showAlert('当前网络不稳定，请检查当前网络状态后，点击「重连」进行重试', () => {
      this.createReconnectTimer();
    });
  };
  createSendHeartTimer = () => {
    this.worker.postMessage({ type: 'createSendHeartTimer' });
  };

  createReconnectTimer = () => {
    this.worker.postMessage({ type: 'createReconnectTimer' });
  };

  // 30秒接收不到心跳自动断开
  createCloseConnectionTimer = () => {
    this.worker.postMessage({ type: 'createCloseConnectionTimer' });
  };

  doConnect = () => {
    this.worker.postMessage({ type: 'doConnect' });
  };

  doReconnect = () => {
    this.worker.postMessage({ type: 'doReconnect' });
  };

  // 暂未有调用的地方。
  close = () => {
    throw new Error("Don't manual close socket connection!");
    // if (this.sockJsInstance) {
    //   this.sockJsInstance.close();
    //   this.sockJsInstance = null;
    // }
  };
}

export default SocketConnect;
